<template>
  <div v-if="site" class="app-footer">
    <div class="app-footer__subscribe is-hidden-tablet">
      <subscribe-form></subscribe-form>
    </div>
    <footer class="nimbus-sans underline-links">
      <links class="is-hidden-mobile" :links="this.site.data['site.footer_links_1'].value" />
      <links class="right is-hidden-mobile" :links="this.site.data['site.footer_links_2'].value" />
      <links class="h8 is-hidden-tablet" :links="this.site.data['site.footer_mobile_links_1'].value" />
    </footer>
  </div>
</template>

<script>
import Links from 'src/components/FooterLinks'
import SubscribeForm from 'src/components/SubscribeForm'
export default {
  name: 'AppFooter',
  props: ['site'],
  components: {
    Links,
    SubscribeForm
  }
}
</script>

<style lang="scss">
@import '../style/variables';

.app-footer{
  > footer{
    display:flex;
    justify-content: space-between;
    flex-wrap:wrap;
    border-top: 1px solid;
    padding:0 $gutter/2;
    [data-route="Collections"] &{
      @include above_mobile () {
        border:none;  
      }
    }
    > ul{
      flex:1 0 auto;
      display: flex;
      &.right{
        justify-content: flex-end;
      }
      @media (min-width:$bkpt-mobile) and (max-width:750px) {
        li {
          @include h8();
        }
      }
    }
  }
}

@media (max-width:$bkpt-mobile){
  .app-footer > footer{
    display:block;    
    > ul.is-hidden-tablet{
      display:flex;
      justify-content: space-between;
      padding-left:$gutter;
      padding-right:$gutter;
      // flex-wrap:wrap;
      li{
        margin-left:0;
        margin-right:0;
      }
    }
    &.underline-links a{
      &:after{
        display:none !important;
      }
    }
  }
  .app-footer__subscribe{
    border-top: 1px solid;
    padding:5em $collectionMobile-textMargin-ew;
    [data-route="Collections"] &{
      border-top: none;
    }
  }
}

@media (max-width:360px) {
  .app-footer > footer ul{
    @include h9();
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?80109a1e